import { useState } from 'react';

export const useStripePortalPayment = () => {
  const [paymentSuccessfullyCompleted, setPaymentSuccessfullyCompleted] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  return {
    paymentSuccessfullyCompleted,
    setPaymentSuccessfullyCompleted,
    showSuccessMessage,
    setShowSuccessMessage,
  };
};
